export default __webpack_public_path__ + "static/media/home.a8207812.svg";